@if (isOpen()) {
    <div
        class="mobile-drawer-backdrop fixed inset-0 top-16 z-50 flex bg-slate-900/50 backdrop-blur-xs md:hidden"
        (click)="onClose()"
        role="dialog"
        aria-modal="true"
        aria-label="Mobile Navigation"
    >
        <div
            class="mobile-drawer-panel flex h-full w-full max-w-sm flex-col overflow-hidden bg-white shadow-2xl sm:max-w-md"
            (click)="$event.stopPropagation()"
        >
            <!-- Scrollable Body with Clean Touch Items -->
            <div
                class="flex-1 space-y-3.5 overflow-y-auto overscroll-contain p-4"
            >
                <!-- 1. DEALS ACCORDION -->
                <div
                    class="overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-xs"
                >
                    <button
                        type="button"
                        class="flex w-full items-center justify-between bg-slate-50/70 p-4 text-left text-sm font-semibold text-slate-900 transition-colors hover:bg-slate-50 active:bg-slate-100"
                        (click)="toggleAccordion('deals')"
                    >
                        <span class="flex items-center gap-3">
                            <span
                                class="text-primary flex h-8 w-8 items-center justify-center rounded-lg bg-blue-50"
                            >
                                <ng-icon
                                    name="lucideShoppingBag"
                                    class="h-4 w-4"
                                />
                            </span>
                            <span>Deals & Categories</span>
                        </span>
                        <ng-icon
                            name="lucideChevronDown"
                            class="h-4 w-4 text-slate-400 transition-transform duration-200"
                            [class.rotate-180]="mobileAccordion() === 'deals'"
                        />
                    </button>

                    @if (mobileAccordion() === 'deals') {
                        <div class="space-y-3 border-t border-slate-100 p-2">
                            @for (
                                group of dealGroups();
                                track group.groupTitle
                            ) {
                                <div class="pt-2 first:pt-1">
                                    <p
                                        class="px-3 pb-1.5 text-[10px] font-bold tracking-wider text-slate-400 uppercase"
                                    >
                                        {{ group.groupTitle }}
                                    </p>
                                    <div class="space-y-1">
                                        @for (
                                            item of group.items;
                                            track item.title
                                        ) {
                                            <button
                                                type="button"
                                                (click)="
                                                    navigateToCategory(
                                                        item.slug
                                                    )
                                                "
                                                class="flex min-h-[48px] w-full items-center gap-3.5 rounded-xl p-2.5 text-left text-slate-700 transition-colors hover:bg-slate-50 active:bg-slate-100"
                                            >
                                                <div
                                                    class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-slate-100"
                                                >
                                                    <img
                                                        [src]="item.image"
                                                        [alt]="item.title"
                                                        class="h-5 w-5 object-contain"
                                                    />
                                                </div>
                                                <div class="min-w-0 flex-1">
                                                    <p
                                                        class="text-sm leading-tight font-semibold text-slate-800"
                                                    >
                                                        {{ item.title }}
                                                    </p>
                                                    <p
                                                        class="mt-0.5 truncate text-xs text-slate-400"
                                                    >
                                                        {{ item.description }}
                                                    </p>
                                                </div>
                                                <ng-icon
                                                    name="lucideChevronRight"
                                                    class="ml-auto h-4 w-4 shrink-0 text-slate-300"
                                                />
                                            </button>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>

                <!-- 2. FUN ACCORDION -->
                <div
                    class="overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-xs"
                >
                    <button
                        type="button"
                        class="flex w-full items-center justify-between bg-slate-50/70 p-4 text-left text-sm font-semibold text-slate-900 transition-colors hover:bg-slate-50 active:bg-slate-100"
                        (click)="toggleAccordion('fun')"
                    >
                        <span class="flex items-center gap-3">
                            <span
                                class="flex h-8 w-8 items-center justify-center rounded-lg bg-amber-50 text-amber-600"
                            >
                                <ng-icon name="lucideTrophy" class="h-4 w-4" />
                            </span>
                            <span>Fun & Activities</span>
                        </span>
                        <ng-icon
                            name="lucideChevronDown"
                            class="h-4 w-4 text-slate-400 transition-transform duration-200"
                            [class.rotate-180]="mobileAccordion() === 'fun'"
                        />
                    </button>

                    @if (mobileAccordion() === 'fun') {
                        <div class="space-y-3 border-t border-slate-100 p-3">
                            <!-- Raffle Card -->
                            <div
                                class="rounded-xl border border-amber-200/70 bg-amber-50/40 p-3.5"
                            >
                                <div class="mb-1.5 flex items-center gap-2.5">
                                    <div
                                        class="flex h-7 w-7 items-center justify-center rounded-lg bg-amber-100 text-amber-700"
                                    >
                                        <ng-icon
                                            name="lucideTrophy"
                                            class="h-3.5 w-3.5"
                                        />
                                    </div>
                                    <h4
                                        class="text-sm font-bold text-slate-900"
                                    >
                                        Raffles & Draws
                                    </h4>
                                </div>
                                <p class="mb-3 text-xs text-slate-600">
                                    Participate in exciting draws and win
                                    rewards.
                                </p>
                                <div class="flex items-center gap-2">
                                    <a
                                        routerLink="/client/raffle"
                                        (click)="onClose()"
                                        class="bg-primary hover:bg-primary/90 inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold text-white shadow-xs transition-colors"
                                    >
                                        <span>Enter Raffles</span>
                                        <ng-icon
                                            name="lucideArrowRight"
                                            class="h-3 w-3"
                                        />
                                    </a>
                                    <a
                                        routerLink="/client/raffle/winners"
                                        (click)="onClose()"
                                        class="px-2 py-1.5 text-xs font-medium text-slate-600 hover:text-slate-900"
                                    >
                                        Winners Podium
                                    </a>
                                </div>
                            </div>

                            <!-- Quiz Card -->
                            <div
                                class="rounded-xl border border-indigo-200/70 bg-indigo-50/40 p-3.5"
                            >
                                <div class="mb-1.5 flex items-center gap-2.5">
                                    <div
                                        class="flex h-7 w-7 items-center justify-center rounded-lg bg-indigo-100 text-indigo-700"
                                    >
                                        <ng-icon
                                            name="lucideHelpCircle"
                                            class="h-3.5 w-3.5"
                                        />
                                    </div>
                                    <h4
                                        class="text-sm font-bold text-slate-900"
                                    >
                                        Trivia & Quizzes
                                    </h4>
                                </div>
                                <p class="mb-3 text-xs text-slate-600">
                                    Challenge yourself with fun quizzes and earn
                                    rewards.
                                </p>
                                <a
                                    routerLink="/quiz"
                                    (click)="onClose()"
                                    class="bg-primary hover:bg-primary/90 inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold text-white shadow-xs transition-colors"
                                >
                                    <span>Play Daily Quizzes</span>
                                    <ng-icon
                                        name="lucideArrowRight"
                                        class="h-3 w-3"
                                    />
                                </a>
                            </div>
                        </div>
                    }
                </div>

                <!-- 3. JOBS DIRECT LINK -->
                <a
                    routerLink="/jobs"
                    (click)="onClose()"
                    class="flex w-full items-center justify-between rounded-2xl border border-slate-200/90 bg-white p-4 shadow-xs transition-colors hover:bg-slate-50 active:bg-slate-100"
                >
                    <span class="flex items-center gap-3">
                        <span
                            class="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-50 text-emerald-600"
                        >
                            <ng-icon name="lucideBriefcase" class="h-4 w-4" />
                        </span>
                        <span class="text-sm font-semibold text-slate-900"
                            >Jobs & Careers</span
                        >
                    </span>
                    <ng-icon
                        name="lucideChevronRight"
                        class="h-4 w-4 text-slate-300"
                    />
                </a>

                <!-- 4. Member Quick Links -->
                <div class="space-y-1 border-t border-slate-100 pt-3">
                    <p
                        class="px-2 pb-1 text-[10px] font-bold tracking-wider text-slate-400 uppercase"
                    >
                        Account & Member Links
                    </p>
                    @if (showClientDashboard()) {
                        <a
                            routerLink="/client/dashboard"
                            (click)="onClose()"
                            class="flex min-h-[48px] items-center gap-3 rounded-xl p-2.5 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 active:bg-slate-100"
                        >
                            <div
                                class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-600"
                            >
                                <ng-icon
                                    name="lucideLayoutDashboard"
                                    class="h-4 w-4"
                                />
                            </div>
                            <span>Dashboard</span>
                        </a>
                    }
                    <button
                        type="button"
                        (click)="navigateToClaimedItems()"
                        class="flex min-h-[48px] w-full items-center gap-3 rounded-xl p-2.5 text-left text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 active:bg-slate-100"
                    >
                        <div
                            class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-600"
                        >
                            <ng-icon
                                name="lucideShoppingCart"
                                class="h-4 w-4"
                            />
                        </div>
                        <span>Claimed Items & Vouchers</span>
                    </button>
                    <a
                        routerLink="/client/profile"
                        (click)="onClose()"
                        class="flex min-h-[48px] items-center gap-3 rounded-xl p-2.5 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 active:bg-slate-100"
                    >
                        <div
                            class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-600"
                        >
                            <ng-icon name="lucideUser" class="h-4 w-4" />
                        </div>
                        <span>My Profile</span>
                    </a>
                </div>
            </div>

            <!-- Footer Auth Action -->
            <div class="shrink-0 border-t border-slate-100 bg-slate-50/90 p-4">
                @if (isLoggedIn()) {
                    <div class="mb-3 flex items-center gap-3">
                        <div
                            class="bg-primary flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white shadow-xs"
                        >
                            {{ displayInitials() }}
                        </div>
                        <div class="min-w-0 flex-1">
                            <p
                                class="truncate text-sm font-bold text-slate-900"
                            >
                                {{ displayName() }}
                            </p>
                            <p class="truncate text-xs text-slate-500">
                                {{ displayEmail() || displayRole() }}
                            </p>
                        </div>
                    </div>
                    <button
                        type="button"
                        (click)="onLogout()"
                        class="flex w-full items-center justify-center gap-2 rounded-xl border border-rose-200 bg-rose-50 py-2.5 text-xs font-semibold text-rose-600 transition-colors hover:bg-rose-100 active:bg-rose-200"
                    >
                        <ng-icon name="lucideLogOut" class="h-4 w-4" />
                        <span>Log Out</span>
                    </button>
                } @else {
                    <a
                        routerLink="/login"
                        (click)="onClose()"
                        class="bg-primary hover:bg-primary/90 active:bg-primary/80 flex w-full items-center justify-center gap-2 rounded-xl py-3 text-sm font-semibold text-white shadow-xs transition-colors"
                    >
                        <ng-icon name="lucideUser" class="h-4 w-4" />
                        <span>Sign In to Cj Club</span>
                    </a>
                }
            </div>
        </div>
    </div>
}
